import AppIcon from '../icons/AppIcon'
import Avatar from '../primitives/Avatar'
import type { NotificationDisplay } from './notificationDisplay'
import styles from './Notifications.module.css'

interface NotificationItemProps {
  item: NotificationDisplay
  onSelect: () => void
}

export default function NotificationItem({ item, onSelect }: NotificationItemProps) {
  const iconClass =
    item.iconTone === 'green'
      ? styles.iconTileGreen
      : item.iconTone === 'blue'
        ? styles.iconTileBlue
        : styles.iconTileOrange

  return (
    <button
      type="button"
      className={[
        styles.item,
        item.read ? styles.itemRead : styles.itemUnread,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onSelect}
    >
      {item.kind === 'avatar' ? (
        <div className={styles.avatarWrap}>
          <Avatar
            initials={item.avatarInitials ?? ''}
            photoUrl={item.avatarPhotoUrl}
            variant={item.isLeader ? 'leader' : 'default'}
            size="sm"
          />
          {item.tagIcon && item.tagTone && (
            <span
              className={[
                styles.avatarTag,
                item.tagTone === 'orange' ? styles.tagOrange : styles.tagBlue,
              ].join(' ')}
            >
              <AppIcon icon={item.tagIcon} size={11} />
            </span>
          )}
        </div>
      ) : (
        <div className={[styles.iconTile, iconClass].join(' ')}>
          <AppIcon icon={item.icon ?? 'mdi:bell'} size={20} />
        </div>
      )}

      <div className={styles.bodyContent}>
        <div className={styles.text}>{item.text}</div>
        {item.sub && <div className={styles.sub}>{item.sub}</div>}
        <div className={styles.time}>{item.time}</div>
      </div>

      <div className={styles.right}>
        <span className={styles.dot} />
        {item.rm && (
          <span className={[styles.rm, item.rm.tone === 'blue' && styles.rmBlue].filter(Boolean).join(' ')}>
            {item.rm.value}
            <span className={styles.rmUnit}>{item.rm.unit}</span>
          </span>
        )}
      </div>
    </button>
  )
}
